// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_wt_","cls2":"ChatInterface-cls2_Tjo ChatInterface-cls1_wt_"};